var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoisting2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 63,
    width: 63,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.1,
    cy: 50.98,
    fill: "#fff",
    fillRule: "nonzero",
    opacity: 0.05,
    rx: 10.01,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.1,
    cy: 50.98,
    rx: 10.01,
    ry: 10,
    stroke: "#fff",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.71 25.54l-9.39 9.98-4.7-4.99",
    stroke: "#fff",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.1,
    cy: 10.08,
    fill: "#fff",
    fillRule: "nonzero",
    opacity: 0.05,
    rx: 10.01,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.1,
    cy: 10.08,
    rx: 10.01,
    ry: 10,
    stroke: "#fff",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.23,
    cy: 10.08,
    fill: "#fff",
    fillRule: "nonzero",
    opacity: 0.05,
    rx: 10.01,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.23,
    cy: 10.08,
    rx: 10.01,
    ry: 10,
    stroke: "#fff",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.23,
    cy: 50.98,
    fill: "#fff",
    fillRule: "nonzero",
    opacity: 0.05,
    rx: 10.01,
    ry: 10
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.23,
    cy: 50.98,
    rx: 10.01,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.23 20.08v20.45m10.42 10.45h20.44m10.01-30.9v20.45M20.65 10.08h20.44"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.23,
    cy: 2.3,
    r: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.83 9.96a4.45 4.45 0 014.4-3.75c1.1 0 2.11.39 2.9 1.07s1.34 1.61 1.5 2.69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46 46)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.1,
    cy: 2.2,
    r: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.7 9.86a4.45 4.45 0 014.4-3.75c1.1 0 2.11.39 2.9 1.07s1.34 1.61 1.5 2.69"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.1 4.61v5.47h5.47m-46.34 44.4V50.1m3 4.38v-7m-6 7v-2.19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoisting2);
export default __webpack_public_path__ + "static/media/Hoisting2.e7e5eee89cc5b9702ed7052fbd6accfd.svg";
export { ForwardRef as ReactComponent };